import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import {
  Box,
  Button,
  Card,
  Icon,
  Image,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react';
import IconMicrosoft from 'assets/icons/icon-microsoft.svg?react';
import logo from 'assets/images/logo-patri.svg';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthenticatedUser } from '../hooks/useAuthenticatedUser';

export default function PageLogin() {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { user } = useAuthenticatedUser();

  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [navigate, user]);

  return (
    <>
      <Box w="full" h="6px" bgColor="bg.button.primary" />

      <Stack alignItems="center" mt="72px" pb="80px">
        <Card
          as={Stack}
          alignItems="center"
          borderRadius="20px"
          bgColor="white"
          boxShadow="0px 24px 56px -4px rgba(88, 92, 95, 0.10)"
          gap="35px"
          p="35px"
        >
          <Image src={logo} alt="Patri" w="135px" />

          <AuthenticatedTemplate>
            {!user && <Spinner m="auto" />}
            {user && <Text>Olá, {user.name}!</Text>}
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
            <Button
              onClick={() =>
                instance.loginRedirect({
                  scopes: ['User.Read'],
                  redirectUri: '/login',
                })
              }
              bgColor="#ffffff"
              border="1px solid #8c8c8c"
              borderRadius="0"
              color="#5E5E5E"
              fontFamily={'"Segoe UI", sans-serif'}
              fontSize="15px"
              fontWeight="600"
              gap="3"
              h="41px"
              mx="auto"
              px="12px"
            >
              <Icon as={IconMicrosoft} />
              <span>Entrar com a Conta da Microsoft</span>
            </Button>
          </UnauthenticatedTemplate>
        </Card>
      </Stack>
    </>
  );
}
